<template>
  <div>
    <comprador />
  </div>
</template>
<script>
import comprador from "./comprador";

export default {
  name: "orcamentoDashboard",
  components: {
    comprador,
  },
  data() {
    return {
      tab: "",
      breadcrumb: "ORÇAMENTO / CONFIGURAÇÃO / COMPRADOR",
    };
  },
  watch: {
    tab() {
      if (this.tab == 1)
        this.breadcrumb = "ORÇAMENTO / CONFIGURAÇÃO / COMPRADOR";
      else if (this.tab == 2)
        this.breadcrumb = "ORÇAMENTO / CONFIGURAÇÃO / FORNECEDOR";
      else if (this.tab == 3)
        this.breadcrumb = "ORÇAMENTO / CONFIGURAÇÃO / SEGMENTO";
    },
  },
};
</script>
<style>
.table-dashboard-resposivo .v-data-table__wrapper {
  height: calc(100vh - 127px) !important;
}

.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > thead
  > tr.header
  > th {
  font-size: 14px !important;
}
.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > thead
  > tr.subheader
  > th {
  top: 35px;
}
.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > thead
  > tr.subheader
  > th:nth-child(4n + 1) {
  min-width: 85px;
  padding-right: 10px;
}
.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > thead
  > tr.subheader
  > th:nth-child(4n + 2) {
  min-width: 90px;
  padding-right: 10px;
}
.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > thead
  > tr.subheader
  > th,
.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > thead
  > tr.header
  > th {
  background-color: #ffffff;
  color: #052333;
  padding: 4px;
  border-right: 2px solid #ddd !important;
  border-left: 0 !important;
  border-top: 1px solid #ddd !important;
  text-align: center;
}

.table-dashboard-resposivo tr td {
  border-bottom: 1px solid #ddd !important;
  border-right: 2px solid #ddd !important;
  border-left: 0 !important;
  text-align: center;
  font-size: 10px !important;
  padding: 0 6px;
}

.table-dashboard-resposivo td.comprador {
  width: 300px;
  max-width: 300px;
  min-width: 300px;
  text-align: left;
}

.table-dashboard-resposivo td.comprador div:last-child {
  border-bottom: 0 !important;
}

.table-dashboard-resposivo td {
  font-weight: 500;
}
.table-dashboard-resposivo tr.expandido td {
  font-weight: 400;
}

.systock-breadcrump {
  background-color: #7979790a;
  height: 2.5em;
}

.v-tabs-bar__content {
  border-bottom: 1px solid #f7f1f1;
  border-top: 1px solid #f7f1f1;
}

.v-card__actions {
  border-top: 1px solid #e0e0e0;
}

.table-striped table > tbody > tr:nth-of-type(odd) {
  background-color: #f2f2f2;
}

.sticky-column-table td:first-child,
.sticky-column-table th:first-child {
  position: sticky;
  left: 0px;
  z-index: 2;
}

.sticky-column-table tr:nth-of-type(even) td:first-child {
  background-color: #fff;
}
.sticky-column-table tr:nth-of-type(odd) td:first-child {
  background-color: #f2f2f2;
}

.sticky-column-table tr.expandido:nth-of-type(odd) td:first-child {
  background-color: #fafafa;
}

.expand .comprador {
  background-color: rgb(242, 242, 242) !important;
}

.sticky-column-table
  .v-data-table__wrapper
  > table
  > thead
  > tr.header
  > th:first-child {
  z-index: 3;
}

.table-dashboard-resposivo
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.expandido
  > td {
  height: 30px;
  border-top: 0 !important;
}
.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > thead
  > tr.subheader
  > th:nth-child(2),
.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > thead
  > tr.subheader
  > th:nth-child(3n + 3),
.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > thead
  > tr.subheader
  > th:nth-child(3n + 2) {
  border-right: 1px solid #ddd !important;
}
.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > thead
  > tr.subheader
  > th:nth-child(1) {
  border-right: 1px solid #ddd !important;
}

.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > tbody
  > tr:not(.trfor)
  > td:nth-child(4n + 2),
.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > tbody
  > tr:not(.trfor)
  > td:nth-child(4n + 3),
.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > tbody
  > tr:not(.trfor)
  > td:nth-child(4n + 4) {
  border-right: 1px solid #ddd !important;
}

.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > tbody
  > tr.trfor
  > td:nth-child(3n + 3),
.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > tbody
  > tr.trfor
  > td:nth-child(3n + 4),
.table-dashboard-resposivo
  .v-data-table__wrapper
  > table
  > tbody
  > tr.trfor
  > td:nth-child(2) {
  border-right: 1px solid #ddd !important;
}

.table-striped table > tbody > tr.expandido:nth-of-type(odd) {
  background-color: #fafafa;
}

.valor_previsto.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
  font-size: 10px;
  text-align: right;
}
.valor_previsto.v-text-field > .v-input__control > .v-input__slot:before {
  border: 0;
}
.valor_previsto input {
  text-align: right;
}
.valor_previsto input:focus {
  border: 0;
}
.valor_previsto input:focus {
  width: 80px;
  border-bottom: 1px solid;
}

.table-dashboard-resposivo button.sort {
  position: absolute;
  width: 13px;
  height: 18px;
  margin-left: 6px;
}
.table-dashboard-resposivo button.sort i {
  width: 13px;
}

.subheader .v-icon.mdi-chevron-up {
  height: 13px;
  font-size: 15px;
  width: 13px;
}
.subheader .v-icon.mdi-chevron-down {
  height: 13px;
  font-size: 15px;
  width: 13px;
}

.torcamento tr td {
  width: 100px;
  max-width: 100px;
  min-width: 100px;
}

.torcamento tr td.tporce {
  width: 50px !important;
  max-width: 50px !important;
  min-width: 50px !important;
}
</style>
